const Style = ({ attributes, clientId }) => {
	const { counters = [], columnGap, rowGap, background, padding, textAlign, counterWidth, counterHeight, iconSize, numberTypo, labelTypo, counterPadding, counterBorder, counterShadow } = attributes;

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${numberTypo?.googleFontLink ? `@import url(${numberTypo?.googleFontLink});` : ''}
			${labelTypo?.googleFontLink ? `@import url(${labelTypo?.googleFontLink});` : ''}
			
			#ctrbCounters-${clientId} .ctrbCounters{
				grid-gap: ${rowGap} ${columnGap};
				${background?.styles || `background-color: #0000;`}
				padding: ${padding?.styles || '20px 0px'};
			}
			#ctrbCounters-${clientId} .ctrbCounters .ctrbCounter{
				text-align: ${textAlign};
				width: ${'0px' === counterWidth || '0%' === counterWidth || '0em' === counterWidth ? '250px' : counterWidth};
				height: ${'0px' === counterHeight || '0%' === counterHeight || '0em' === counterHeight ? '250px' : counterHeight};
				padding: ${counterPadding?.styles || '20px 20px'};
				${counterBorder?.styles || 'border-radius: 50%;'}
				box-shadow: ${counterShadow?.styles || 'none'};
			}
			#ctrbCounters-${clientId} .ctrbCounters .ctrbCounter .counterIcon i, #ctrbCounters-${clientId} .ctrbCounters .ctrbCounter .counterIconLabel i{
				font-size: ${iconSize || 50}px
			}
			#ctrbCounters-${clientId} .ctrbCounters .ctrbCounter .counterNumber{
				${numberTypo?.styles || 'font-size: 48px'}
			}
			#ctrbCounters-${clientId} .ctrbCounters .ctrbCounter .counterLabel{
				${labelTypo?.styles || 'font-size: 22px;'}
			}
			`.replace(/\s+/g, ' ')
		}} />

		<style>
			{counters?.map((item, index) => `
				#ctrbCounters-${clientId} #ctrbCounter-${index} .ctrbCounter{
					${item.background?.styles || `background-color: #4527a4;`}
				}
				#ctrbCounters-${clientId} #ctrbCounter-${index} .counterIcon i, #ctrbCounters-${clientId} #ctrbCounter-${index} .counterIconLabel i{
					${item.icon?.styles || 'color: #fff;'}
				}
				#ctrbCounters-${clientId} #ctrbCounter-${index} .counterNumber{
					color: ${item.number.color};
				}
				#ctrbCounters-${clientId} #ctrbCounter-${index} .counterLabel{
					color: ${item.label.color};
				}
			`.replace(/\s+/g, ' '))}
		</style>
	</>
}
export default Style;